export default __webpack_public_path__ + "static/media/open.e887b059.svg";